<template>
  <div>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
        v-if="independentServicesConnect"
        :items="independentServicesConnect"
        :fields="independentServicesConnectFields"
        @ClickOnDeleteButton="ClickOnDeleteButton"
        @ClickOnEditButton="editItem"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"
        isDelete="true"
        isEdit="true"/>
    <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    <editModal :editItem="selectedindependentServicesConnect"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  data () {
    return {
      independentServicesConnectFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'group_id',
          label: this.$i18n.t('Group'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 0) {
              return this.$t('All') + '(0)'
            }
            for (let el of this.groups) {
              if (val === el.group_id) {
                return el.group_name + '(' + val + ')'
              }
            }
            return val
          }},
        {key: 'service_id',
          label: this.$i18n.t('Service'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 0) {
              return this.$t('Disabled') + '(0)'
            }
            for (let el of this.services) {
              if (val === el.service_id) {
                return el.service_name + '(' + val + ')'
              }
            }
            return val
          }},
        {key: 'tariff_id',
          label: this.$i18n.t('Tariff'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 0) {
              return this.$t('Disabled') + '(0)'
            }
            for (let el of this.tariffs) {
              if (val === el.value) {
                return el.text + '(' + val + ')'
              }
            }
            return val
          }},
        {key: 'accounting_period_id',
          label: this.$i18n.t('Accounting period'),
          sortable: true,
          formatter: (val, key, item) => {
            for (let el of this.accountingPeriods) {
              if (val === el.value) {
                return el.text
              }
            }
            return val
          }},
        {key: 'is_enabled', label: this.$i18n.t('Active'), sortable: true, formatter: (val, key, item) => { return val ? this.$t('Yes') : this.$t('No') }},
        {key: 'is_bonus_enabled', label: this.$i18n.t('Bonus active'), sortable: true, formatter: (val, key, item) => { return val ? this.$t('Yes') : this.$t('No') }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedindependentServicesConnect: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  components: {
    editModal
  },
  methods: {
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Services and tariffs connect"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_INDEPENDENT_SERVICES_CONNECT', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_INDEPENDENT_SERVICES_CONNECT')
          this.$root.$emit('makeToasts')
        }
      })
    },
    editItem (item) {
      this.selectedindependentServicesConnect = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditIndependentServicesConnect', '#btnShow')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    showAdd () {
      this.selectedindependentServicesConnect = {
        id: 0,
        name: '',
        group_id: 0,
        service_id: 0,
        tariff_id: 0,
        is_enabled: 0,
        is_bonus_enabled: 0,
        accounting_period_id: 0,
        is_can_be_disabled: 0,
        multiple_linking: 0,
        is_search_ap_in_services: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditIndependentServicesConnect', '#btnShow')
    }
  },
  computed: {
    independentServicesConnect () {
      let tmp = JSON.parse(JSON.stringify(this.$store.getters['Settings/INDEPENDENT_SERVICES_CONNECT']))
      for (let el of tmp) {
        let color = el.is_enabled ? 'success' : 'danger'
        el._cellVariants = {id: color}
      }
      return tmp
    },
    groups () {
      return this.$store.getters['Users/GROUPS']
    },
    services () {
      return this.$store.getters['Tariffing/SERVICES']
    },
    templateServices () {
      let templateServices = this.services
      return templateServices.filter(function (value) {
        return value.parent_id !== 0 && value.tariff_id === 0
      })
    },
    accountingPeriods () {
      let res = []
      for (let el of this.$store.getters['Tariffing/ACCOUNTING_PERIODS']) {
        if (el.id === 1) {
          continue
        }
        let newEl = {}
        newEl.value = el.id
        let accPeriodName = ''
        switch (el.periodic_type) {
          case 1:
            accPeriodName = this.$i18n.t('Daily')
            break
          case 2:
            accPeriodName = this.$i18n.t('Weekly')
            break
          case 3:
            accPeriodName = this.$i18n.t('Monthly')
            break
          case 4:
            accPeriodName = this.$i18n.t('Quarterly')
            break
          case 5:
            accPeriodName = this.$i18n.t('Annual')
            break
          default:
            accPeriodName = this.$i18n.t('CustomDuration')
            break
        }
        newEl.text = el.id + ' (' + this.$root.getMomentWithTZDelta(Number(el.begin)).format('DD-MM-YYYY') + '-' + this.$root.getMomentWithTZDelta(Number(el.end)).format('DD-MM-YYYY') + ') ' + accPeriodName
        res.push(newEl)
      }
      return res
    },
    tariffs () {
      let res = []
      res.push({value: 0, text: this.$t('Disabled')})
      for (let el of this.$store.getters['Tariffing/TARIFFS']) {
        if (el.id === 0) {
          continue
        }
        let newEl = {}
        newEl.value = el.id
        newEl.text = el.name
        res.push(newEl)
      }
      return res
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_TARIFFS')
    this.$store.dispatch('Tariffing/GET_SERVICES')
    this.$store.dispatch('Settings/GET_INDEPENDENT_SERVICES_CONNECT')
    this.$store.dispatch('Users/GET_GROUPS')
    this.$store.dispatch('Tariffing/GET_ACCOUNTING_PERIODS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/customerIndependentServiceConnect/main.vue